import { Route } from '@angular/router';

export const armRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'wall',
    pathMatch: 'full',
  },
  {
    path: 'wall',
    loadComponent: () => import('./pages').then(m => m.ArmWallComponent),
    title: 'UIMS - ARM',
  },
  {
    path: 'events',
    loadComponent: () => import('./pages').then(m => m.EventsJournalPage),
    title: 'UIMS - Events',
  },
  {
    path: 'journal',
    loadComponent: () => import('./pages').then(m => m.SessionsJournalPage),
    title: 'UIMS - Journal',
  },
  {
    path: 'payments',
    loadComponent: () => import('./pages').then(m => m.PaymentsViewPage),
    title: 'UIMS - Payments',
  },
  {
    path: 'tariffs',
    loadComponent: () => import('./pages').then(m => m.TariffsViewPage),
    title: 'UIMS - Tariffs',
  },
  {
    path: 'board',
    loadComponent: () => import('./pages').then(m => m.BoardViewPage),
    title: 'UIMS - Board',
  },
  {
    path: 'whitelist-view',
    loadComponent: () => import('./pages').then(m => m.WhitelistViewPage),
    title: 'UIMS - Whitelist',
  },
  {
    path: 'blacklist-view',
    loadComponent: () => import('./pages').then(m => m.BlacklistViewPage),
    title: 'UIMS - Blacklist',
  },
  {
    path: 'manual-opens',
    loadComponent: () => import('./pages').then(m => m.ManualOpensViewPage),
    title: 'UIMS - Manual opens',
  },
  {
    // Лояльность (Phase 5) — ЗАГЛУШКА на моках (Decision 6/OUT), backend нет.
    path: 'loyalty',
    loadComponent: () => import('./pages').then(m => m.LoyaltyViewPage),
    title: 'UIMS - Loyalty',
  },
];
